import axios from "axios";
import { mapState } from "vuex";
import { Toast, Dialog } from "vant";

export default {
  data() {
    return {
      loading: false,
      env: process.env,
      detail: {},
      isCheck: true, // 当前登录人判断
      form: {
        orderId: "",
        voucherUrlList: [],
        voucherUrlUploadedList: []
      },
      fileList: [],
      maxCount: 20,
      disList: []
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    const { orderId } = this.$route.query;
    this.form.orderId = orderId || "";
    Toast.loading({
      mask: true,
      message: "加载中...",
      duration: 0
    });
    this.getDetail();
  },
  methods: {
    getDetail() {
      const { orderId } = this.form;
      this.$store.dispatch("order/replaceVouher/queryReplaceUploadVoucherByOrderId", {
        orderId
      }).then((data) => {
        this.loading = true;
        const { phoneList, receiptOrderVo } = data;
        this.isCheck = receiptOrderVo.isSign === 1;
        this.detail = receiptOrderVo || {};
        this.disList = phoneList || [];
      }).finally(() => {
        Toast.clear();
      });
    },
    // 上传图片
    afterRead(file) {
      const { orderId } = this.form;
      const count = this.fileList.length;
      let fileArray = [];
      if (Array.isArray(file)) {
        fileArray = file;
        if (file.length + this.form.voucherUrlUploadedList.length + count > this.maxCount) {
          fileArray = file.slice(0, this.maxCount);
        }
      } else {
        fileArray.push(file);
      }
      fileArray.forEach((item) => {
        item.status = "uploading";
        item.message = "上传中...";
        // 此时可以自行将文件上传至服务器
        const formData = new FormData(); // 声明一个FormData对象
        formData.append("file", item.file);
        axios.post(`${process.env.VUE_APP_APP}file/uploadFile.do`, formData, {
          headers: { "content-type": "multer/form-data" }
        }).then((res) => {
          item.status = "";
          item.message = "";
          const fileUrl = res.data.substring(res.data.indexOf("http"));
          item.url = fileUrl;
          this.$store.dispatch("order/signature/checkUploadOrderVoucher", {
            orderId,
            voucherImgUrl: fileUrl
          }).then((res1) => {
            console.log("res1", res1);
            if (res1.code !== "0") {
              this.fileList.splice(this.fileList.length - 1, 1);
              Dialog.alert({ message: res1.msg });
            }
          });
        }).catch(() => {
          file.status = "failed";
          file.message = "上传失败";
        });
      });
    },
    // 返回布尔值
    beforeRead(file) {
      let fileArray = [];
      if (Array.isArray(file)) {
        fileArray = file;
      } else {
        fileArray.push(file);
      }
      console.log("fileArray", fileArray);
      for (const item of fileArray) {
        if (item.size && item.size >= 10 * 1024 * 1024) {
          Toast("上传文件过大，文件大小不能大于10M");
          return false;
        }
        if (item.type !== "image/jpeg" && item.type !== "image/jpg" && item.type !== "image/png") {
          Toast("请上传正确的图片格式");
          return false;
        }
      }
      return true;
    },
    upVoucher() {
      const { form, fileList } = this;
      Dialog.confirm({
        title: "提示",
        message: "确定上传凭证"
      })
        .then(() => {
          const voucherUrlList = fileList.map((item) => item.url);
          Toast.loading({
            mask: true,
            message: "上传确认中...",
            duration: 0
          });
          this.$store.dispatch("order/replaceVouher/upVoucherUrlByShipper", {
            ...form,
            voucherUrlList
          }).then((res) => {
            const { code, msg } = res;
            setTimeout(() => {
              if (code === "0") {
                Toast.success("上传成功！");
                this.getDetail();
                this.fileList = [];
              } else {
                Toast(msg);
              }
            }, 100);
          }).finally(() => {
            Toast.clear();
          });
        });
    },

    // 退出登录
    logBackIn() {
      // https://cas.t.nxin.com/cas/logout?service=xxx
      window.location.href = `${this.env.VUE_APP_CAS_NEW}cas/logout?service=${encodeURIComponent(window.location.href)}`;
    }
  }
};
